import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentpune() {



  const cardData = {


  keyword: "Innova Crysta on Rent in Pune",

  headingDescription: "Trustline Travels offers premium Innova Crysta on rent in Pune for corporate travel, airport transfers, family trips, outstation journeys, business meetings, wedding transportation, and group travel. Toyota Innova Crysta is an ideal choice for travelers looking for luxury, spacious seating, powerful performance, and a comfortable long-distance ride. Whether you need an Innova Crysta for one day, multiple days, one-way travel, round trips, or customized packages, our professional chauffeurs ensure a safe and smooth journey. With well-maintained vehicles, experienced drivers, transparent pricing, doorstep pickup, easy online booking, flexible rental plans, and 24/7 customer support, Trustline Travels is your trusted choice for Innova Crysta rental services in Pune.",

 topPlaces: [
  {
    title: "Mumbai Airport",
    description: "Mumbai Airport is a major travel hub for domestic and international passengers. Innova Crysta rental from Pune to Mumbai Airport is preferred for comfortable airport transfers, family travel, and corporate journeys."
  },
  {
    title: "Bandra",
    description: "Bandra is one of Mumbai's premium destinations known for corporate offices, shopping streets, restaurants, sea-facing locations, and entertainment hubs. It is a popular destination for Pune to Mumbai Innova Crysta bookings."
  },
  {
    title: "Hinjewadi IT Park",
    description: "Hinjewadi IT Park is Pune's leading technology hub featuring multinational companies, IT offices, and business campuses. Innova Crysta rentals are widely used for corporate travel and executive transportation."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and green valleys. It is a popular destination for family trips and weekend getaways."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station near Pune known for strawberry farms, viewpoints, lakes, waterfalls, and pleasant weather. It is an ideal destination for comfortable long-distance Innova Crysta rentals."
  },
  {
    title: "Navi Mumbai",
    description: "Navi Mumbai is a major commercial and residential region featuring corporate offices, industrial zones, business parks, and modern infrastructure. It is a common destination for Pune-based cab rentals."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a planned hill city near Pune offering lakeside views, adventure activities, scenic roads, and peaceful surroundings. It is a popular tourist destination for group travel."
  },
  {
    title: "Pune Airport",
    description: "Pune Airport is a key transportation point for business travelers and tourists. Innova Crysta rentals provide comfortable airport pickup and drop services with professional drivers."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a coastal getaway near Mumbai famous for beaches, forts, and relaxing weekend trips. It is a preferred outstation destination for families and groups."
  },
  {
    title: "Matheran",
    description: "Matheran is a peaceful hill station near Mumbai known for viewpoints, greenery, and a pollution-free environment. It is a popular destination for nature lovers and weekend travelers."
  }
],






"services": [
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Book Pune to Mumbai Innova Cab for comfortable outstation travel with Toyota Innova Crysta, spacious seating, professional chauffeurs, AC comfort, luggage space, fixed fares, and reliable one way or round trip journeys."
  },
  {
    "name": "Pune to Mumbai Airport Drop Innova",
    "description": "Reserve Pune to Mumbai Airport Drop Innova for timely airport transfers with experienced drivers, premium vehicles, luggage assistance, doorstep pickup, and smooth highway travel."
  },
  {
    "name": "Mumbai Airport to Pune Innova",
    "description": "Hire Mumbai Airport to Pune Innova for reliable airport pickup with clean AC vehicles, professional chauffeurs, comfortable seating, and 24x7 cab availability."
  },
  {
    "name": "Pune Mumbai Innova Rental",
    "description": "Choose Pune Mumbai Innova Rental for business trips, family travel, airport transfers, and outstation journeys with flexible rental options and chauffeur-driven comfort."
  },
  {
    "name": "Pune to Mumbai Airport Innova",
    "description": "Book Pune to Mumbai Airport Innova cab service with premium Toyota Innova Crysta vehicles, experienced drivers, fixed pricing, and punctual airport drop facility."
  },
  {
    "name": "Innova Crysta on Rent in Pune Airport",
    "description": "Hire Innova Crysta on Rent in Pune Airport for airport pickup, corporate travel, family trips, and outstation journeys with professional drivers and premium comfort."
  },
  {
    "name": "Innova Per Km Rate in Pune",
    "description": "Check Innova Per Km Rate in Pune with transparent pricing, affordable packages, flexible rental plans, and comfortable chauffeur-driven travel options."
  },
  {
    "name": "Pune to Andheri Innova Crysta",
    "description": "Book Pune to Andheri Innova Crysta cab for safe intercity travel with spacious seating, AC comfort, professional drivers, and reliable pickup service."
  },
  {
    "name": "Pune to Mumbai Innova Crysta",
    "description": "Travel with Pune to Mumbai Innova Crysta offering premium seating, luggage space, experienced chauffeurs, fixed fares, and comfortable highway journeys."
  },
  {
    "name": "Pune to Mumbai One Way Innova Crysta",
    "description": "Reserve Pune to Mumbai One Way Innova Crysta for direct travel with luxury comfort, affordable fares, professional drivers, and doorstep pickup."
  },
  {
    "name": "Pune to Mumbai Innova",
    "description": "Book Pune to Mumbai Innova taxi service for family trips, corporate travel, airport transfers, and comfortable outstation transportation."
  },
  {
    "name": "Pune Airport to Mumbai Airport Innova Cab",
    "description": "Choose Pune Airport to Mumbai Airport Innova Cab for seamless airport transfers with premium vehicles, punctual drivers, luggage support, and reliable service."
  },
  {
    "name": "Outstation Innova Car Rental Mumbai",
    "description": "Hire Outstation Innova Car Rental Mumbai for long-distance travel with experienced chauffeurs, spacious interiors, AC comfort, and flexible rental options."
  },
  {
    "name": "Innova Crysta on Rent in Mumbai for Outstation Trip",
    "description": "Book Innova Crysta on Rent in Mumbai for Outstation Trip with luxury seating, professional drivers, affordable packages, and comfortable long-distance travel."
  },
  {
    "name": "Innova Per Km Rate for Outstation",
    "description": "Check Innova Per Km Rate for Outstation travel with transparent charges, flexible packages, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Innova Crysta on Rent in Pune",
    "description": "Rent Innova Crysta on Rent in Pune for airport transfers, family vacations, corporate trips, and outstation journeys with premium comfort and professional drivers."
  },
  {
    "name": "Innova Crysta Rental Pune",
    "description": "Choose Innova Crysta Rental Pune with affordable pricing, clean vehicles, experienced chauffeurs, and flexible rental options for every travel requirement."
  },
  {
    "name": "Innova Crysta Cab in Pune",
    "description": "Book Innova Crysta Cab in Pune for premium travel with spacious seating, AC comfort, luggage capacity, and reliable chauffeur service."
  },
  {
    "name": "Innova Crysta Car Hire Pune",
    "description": "Hire Innova Crysta Car Hire Pune for business travel, family trips, airport transfers, and outstation travel with professional drivers."
  },
  {
    "name": "Book Innova Crysta in Pune",
    "description": "Book Innova Crysta in Pune for comfortable journeys with premium interiors, experienced chauffeurs, fixed fares, and flexible pickup locations."
  },
  {
    "name": "Innova Crysta Taxi Service Pune",
    "description": "Choose Innova Crysta Taxi Service Pune for safe and luxurious transportation with reliable drivers, clean vehicles, and affordable travel packages."
  },
  {
    "name": "Innova Crysta on Hire Pune",
    "description": "Hire Innova Crysta on Hire Pune for local and outstation travel with flexible rental plans, professional chauffeurs, and premium comfort."
  },
  {
    "name": "Toyota Innova Crysta Rental Pune",
    "description": "Book Toyota Innova Crysta Rental Pune for luxury family travel, corporate transportation, airport transfers, and long-distance journeys."
  },
  {
    "name": "Innova Crysta SUV Rental Pune",
    "description": "Choose Innova Crysta SUV Rental Pune with spacious seating, powerful performance, AC comfort, and professional driver service."
  },
  {
    "name": "Cheap Innova Crysta on Rent Pune",
    "description": "Book Cheap Innova Crysta on Rent Pune with affordable rates, well-maintained vehicles, experienced chauffeurs, and comfortable travel solutions."
  },
  {
    "name": "7 Seater Innova Crysta Rental Pune",
    "description": "Hire 7 Seater Innova Crysta Rental Pune for family trips, group travel, airport transfers, and comfortable outstation journeys."
  },
  {
    "name": "Innova Crysta Pune to Mumbai Cab",
    "description": "Book Innova Crysta Pune to Mumbai Cab for premium one way and round trip travel with luxury seating, professional drivers, and reliable service."
  },
  {
    "name": "Innova Crysta Airport Pickup Pune",
    "description": "Reserve Innova Crysta Airport Pickup Pune for timely airport transfers with spacious luggage space, premium comfort, and experienced chauffeurs."
  },
  {
    "name": "Innova Crysta Outstation Cab Pune",
    "description": "Choose Innova Crysta Outstation Cab Pune for safe long-distance travel with fixed fares, luxury vehicles, and professional chauffeur support."
  },
  {
    "name": "Innova Crysta with Driver Pune",
    "description": "Book Innova Crysta with Driver Pune for private travel, corporate trips, family vacations, and comfortable chauffeur-driven journeys."
  }
],

"tableData": [
  ["Pune to Mumbai Innova Cab", "Pune to Mumbai Airport Drop Innova"],
  ["Mumbai Airport to Pune Innova", "Pune Mumbai Innova Rental"],
  ["Pune to Mumbai Airport Innova", "Innova Crysta on Rent in Pune Airport"],
  ["Innova Per Km Rate in Pune", "Pune to Andheri Innova Crysta"],
  ["Pune to Mumbai Innova Crysta", "Pune to Mumbai One Way Innova Crysta"],
  ["Pune to Mumbai Innova", "Pune Airport to Mumbai Airport Innova Cab"],
  ["Outstation Innova Car Rental Mumbai", "Innova Crysta on Rent in Mumbai for Outstation Trip"],
  ["Innova Per Km Rate for Outstation", "Innova Crysta on Rent in Pune"],
  ["Innova Crysta Rental Pune", "Innova Crysta Cab in Pune"],
  ["Innova Crysta Car Hire Pune", "Book Innova Crysta in Pune"],
  ["Innova Crysta Taxi Service Pune", "Innova Crysta on Hire Pune"],
  ["Toyota Innova Crysta Rental Pune", "Innova Crysta SUV Rental Pune"],
  ["Cheap Innova Crysta on Rent Pune", "7 Seater Innova Crysta Rental Pune"],
  ["Innova Crysta Pune to Mumbai Cab", "Innova Crysta Airport Pickup Pune"],
  ["Innova Crysta Outstation Cab Pune", "Innova Crysta with Driver Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta on Rent in Pune",
    WhyChoosedescription: "Trustline Cab provides luxury Innova Crysta rental services in Pune with spacious interiors, professional chauffeurs, and comfortable travel solutions for every occasion."
  },
  {
    WhyChooseheading: "Flexible Pickup Across Pune",
    WhyChoosedescription: "Get convenient pickup from Pune Airport, railway station, hotels, offices, Hinjewadi, Baner, Kharadi, Wakad, Pimpri Chinchwad, and other locations."
  },
  {
    WhyChooseheading: "Spacious Vehicle for Family & Group Travel",
    WhyChoosedescription: "Innova Crysta offers premium seating comfort, ample luggage space, and a smooth ride, making it ideal for families, corporate groups, and long-distance journeys."
  },
  {
    WhyChooseheading: "Professional Chauffeur Driven Service",
    WhyChoosedescription: "Our experienced drivers ensure safe, punctual, and comfortable travel with excellent knowledge of Pune city and outstation routes."
  },
  {
    WhyChooseheading: "Affordable Innova Crysta Rental Plans",
    WhyChoosedescription: "Choose hourly, daily, outstation, one-way, or round-trip rental options with transparent pricing and no hidden charges."
  },
  {
    WhyChooseheading: "Perfect for Multiple Travel Needs",
    WhyChoosedescription: "Hire Innova Crysta for airport transfers, corporate travel, sightseeing, family trips, weddings, business meetings, and outstation travel."
  },
  {
    WhyChooseheading: "Well-Maintained Premium Fleet",
    WhyChoosedescription: "All Innova Crysta vehicles are regularly maintained, clean, and equipped to provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "24/7 Innova Crysta Booking Support",
    WhyChoosedescription: "Book Innova Crysta on rent anytime in Pune with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Innova Crysta on rent in Pune?",
    answer: "Yes, Trustline Travels offers Innova Crysta rental services in Pune for local travel, outstation trips, airport transfers, and corporate requirements."
  },
  {
    question: "Can I hire Innova Crysta with a driver in Pune?",
    answer: "Yes, chauffeur-driven Innova Crysta rental services are available for comfortable and safe travel."
  },
  {
    question: "Where can I get Innova Crysta pickup in Pune?",
    answer: "Pickup is available from Pune Airport, railway station, hotels, offices, residential areas, and major locations across Pune."
  },
  {
    question: "Is Innova Crysta suitable for family and group travel?",
    answer: "Yes, Innova Crysta is perfect for families and groups due to its spacious seating, premium comfort, and large luggage capacity."
  },
  {
    question: "Can I rent Innova Crysta for outstation trips from Pune?",
    answer: "Yes, Innova Crysta is available for destinations like Mumbai, Nashik, Lonavala, Mahabaleshwar, Shirdi, and other outstation locations."
  },
  {
    question: "Is Innova Crysta available for airport transfers?",
    answer: "Yes, we provide Innova Crysta rental services for Pune Airport pickup, drop, and corporate airport transfers."
  },
  {
    question: "What rental options are available for Innova Crysta?",
    answer: "You can hire Innova Crysta on hourly, daily, one-way, round-trip, and customized rental packages."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Can I book Innova Crysta on rent for corporate travel?",
    answer: "Yes, our Innova Crysta rental service is suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Innova Crysta on Rent in Pune with Trustline Travels?",
    answer: "Share your travel date, pickup location, destination, duration, passenger details, and requirements to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Sharma",
    feedback: "We hired Innova Crysta on rent in Pune for a family trip and had a great experience. The vehicle was spacious, clean, and the driver provided excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "Trustline Travels provided a premium Innova Crysta with a professional chauffeur. The booking process was easy and the entire journey was comfortable and well-managed.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Pune",
  "image": "https://www.trustlinetravels.com/assets/images/innova-crysta-on-rent-in-pune.webp",
  "description":
    "Book Innova Crysta on Rent in Pune with Trustline Travels for premium, comfortable, and reliable taxi services. We provide Innova Crysta rentals for Pune to Mumbai, Mumbai Airport transfers, Pune Airport pickup and drop, one-way and round-trip travel with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/innova-crysta-on-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Innova Crysta on Rent in Pune | Premium Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Innova Crysta on Rent in Pune with Trustline Travels for premium one-way and round-trip taxi services. Hire Innova Crysta for Pune to Mumbai, Mumbai Airport, Pune Airport, and outstation travel with experienced drivers available 24x7."
  />

  <meta
    name="keywords"
    content="pune to mumbai innova cab, pune to mumbai airport drop innova, mumbai airport to pune innova, pune mumbai innova rental, pune to mumbai airport innova, innova crysta on rent in pune airport, Innova per km rate in Pune, pune to andheri innova crysta, Innova Crysta on Rent in Pune, Pune Innova Crysta Rental, Innova Taxi Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentpune;